angular.module('jv.candidate.details.messages.controller',[])
    .controller('jvCandDetailsMessagesController', ['$scope','$routeParams','candidates','jvMessagesFactory', '$window',
        function($scope,$routeParams,candidates,jvMessagesFactory,$window){
            var candidateReplyCCEnabled = function() {
                return !$window.disableFlags.candidateReplyCC;
            };
            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            $scope.$parent.jump = 'all';
            var refreshMessages = function(event, data){
                $scope.messages = data;
            };
            $scope.applicationId = $routeParams.applicationId;
            $scope.$root.activeMessageIndex;
            $scope.flags.loading = false;
            $scope.flags.expanded = false;
            $scope.$parent.processing = false;
            // clearing out the messages(maintained in the parent) from earlier.
            $scope.$parent.messages = [];
            $scope.$root.modal = {
                show : false,
                buttons : [ {
                    label : i18n.DELETE,
                    click : function() {
                        $scope.deleteMessage();
                    }
                }, {
                    label : i18n.CANCEL,
                    click : function() {
                        $scope.$root.modal.show = false;
                        $scope.$root.activeMessageIndex = -1;
                    },
                    'class' : 'cancel'
                } ],
                cancel : function() {
                    this.show = false;
                },
                title : i18n.DELETE_MESSAGE,
                body : i18n.DELETE_MESSAGE_CNFRM
            };

            $scope.openFlyout = function(){
                $scope.flags.noteMandetoryFlag = false;
                $scope.flags.quickForms = 'message';
                $scope.showQForm('message');
            };

            $scope.isReplyable = function(message) {
                return jvMessagesFactory.isReplyable(message);
            };

            $scope.$watch('messages', function(newVal){
                if (angular.isArray(newVal)) {
                    angular.forEach(newVal, function(messages, key){
                        if (!$scope.forms[key]){
                            $scope.forms[key] = {};
                        }
                    });
                }
            });

            $scope.$watch('jump', function(newVal){
                if((newVal === 'received' || newVal === 'sent') && ($scope.messages.length !== ($scope.receivedMessages + $scope.sentMessages)))
                {
                    $scope.loadMore();
                }
            });

            $scope.reply = function(index) {
                $scope.messages[index].form = true;
                if($scope.isReceived($scope.messages[index])) {
                    if($.isEmptyObject($scope.quickForm.message)){
                        $scope.getMessageTemplates(function(){
                            if($scope.quickForm && $scope.quickForm.message){
                                $scope.messageTemplates = $scope.select2Options.setTemplates($scope.quickForm.message.templates);
                            }
                        });
                    }else{
                        if($scope.quickForm && $scope.quickForm.message){
                            $scope.messageTemplates = $scope.select2Options.setTemplates($scope.quickForm.message.templates);
                        }
                    }

                    $scope.forms[index] = {
                        to : $scope.messages[index].from.EId,
                        template: '',
                        subject:$scope.messages[index].subject,
                        content:''
                    };
                    if (candidateReplyCCEnabled()) {
                        $scope.forms[index].cc = $scope.messages[index].cc.filter(function(cc) {
                            return cc.EId !== $window._jvselfUser.eid;
                        }).map(function(cc) {
                            return cc.EId;
                        });
                        if ($scope.messages[index].from.EId !== $scope.appDetails.application.userEId) {
                            $scope.forms[index].cc.push($scope.messages[index].from.EId);
                        }
                    }
                } else{
                    if($.isEmptyObject($scope.quickForm.note)){
                        $scope.getNoteTemplates();
                    }
                    $scope.notes = [];
                    $scope.notes[index] = $scope.messages[index];
                    $scope.forms[index] = {
                        to : $scope.messages[index].from.EId,
                        template: '',
                        subject: $scope.messages[index].subject,
                        content: ''
                    };
                }
            };

            $scope.loadMore = function(){
                $scope.$parent.processing=true;
                $scope.getMessages($scope.messages ? $scope.messages.length : 0, $scope.page.count, function(messages){
                    if(messages){
                        refreshMessages(null, $scope.messages.concat(messages));
                    }
                    $scope.$parent.processing=false;
                });
            };

            $scope.hasMore = function(){
                var count = $scope.jump === 'received' ? $scope.receivedMessages : ($scope.jump === 'sent' ? $scope.sentMessages : ($scope.receivedMessages+$scope.sentMessages));
                return $scope.messages.length < count;
            };

            $scope.openMessage = function(message) {
                message.isReceived = $scope.isReceived(message);
                $window.localStorage.message = JSON.stringify(message);
                window.open($scope.jvUrls.jhire+'/modules/candidates/details/messageDetail.html','_blank','width=1200, height=600, scrollbars=yes');
            };

            $scope.deleteMessage = function(){
                if(!($scope.$root.activeMessageIndex >=0)){
                    return;
                }
                $scope.$root.modal.show = false;
                $scope.flags.loading = true;
                $scope.messages[$scope.$root.activeMessageIndex].form = false;
                var data = {
                    id: $scope.messages[$scope.$root.activeMessageIndex].eid,
                    applicationId: $routeParams.applicationId
                };
                // Delete it from the displayed messages - length of messages array is used later and deleting this will reflect the actual length
                $scope.messages.splice($scope.$root.activeMessageIndex, 1);
                candidates.deleteMessage(data,function(data){
                    if(data.msgInfo === $scope.status.OK){
                        $scope.$root.activeMessageIndex = -1;
                        $scope.flags.deleted = true;
                        setTimeout(function(){
                            $scope.flags.deleted = false;
                        },500);
                        $scope.getMessages(0, !($.isEmptyObject($scope.messages))?$scope.messages.length+1:$scope.page.count, null, 0);
                        $scope.getMessagesCount(0);
                        $scope.flags.loading = false;
                    }
                });
            };

            $scope.confirmDelete = function(index){
                $scope.$root.modal.show = true;
                $scope.$root.activeMessageIndex = index;
            };

            function ifMessageSentByCurrentUser(message, currentApplication){
                return message.from && message.from.EId === currentApplication.userEId;
            }

            function ifMessageSentByCandidate(message, currentApplication){
                return message.from && currentApplication.candidate && message.from.email.toLowerCase() === currentApplication.candidate.email.toLowerCase();
            }

            /*
             * Checks if the message was sent by the candidate.(if yes, it is a message received by the logged in user from the Candidate).
             *  For agency candidate check if from email is equal to appDetails.candidate.email.
             *
             */
            $scope.isReceived = function(message){
                var currentApplication = (window.__applicationDetails.details && window.__applicationDetails.details.application) || $scope.appDetails.application;
                return currentApplication && message && message.from && (ifMessageSentByCandidate(message, currentApplication) || ifMessageSentByCurrentUser(message, currentApplication) || candidateReplyCCEnabled && jvMessagesFactory.findUser(message.cc));
            };

            // Tab was clicked
            if($scope.$parent.tabClicked === 'messages'){
                $scope.getMessages(0, $scope.page.count);
                $scope.getMessagesCount();
            }else if($scope.activeTab('messages')){
                // Page was refreshed, not a tab click
                $scope.getMessages(0, $scope.page.count);
                $scope.getApplicationDetails();
            }
            $scope.$on('load_application_messages', refreshMessages);
    }]);
